module.exports = __webpack_public_path__ + "img/banner0108.4dee5a8c.png";